import { createFileRoute } from '@tanstack/react-router'

import { MENU } from '@/constants/common/message.constants'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/package-categories/create'
)({
  loader: async ({ context: { auth } }) => {
    return {
      authUser: auth.user
    }
  },
  meta: () => [{ title: MENU.NEW_REGISTRATION }]
})
